// Task runs filtered by campaign — TanStack Query hook

import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { TaskRun } from "../../../shared/types";

export function useRunsByCampaign(brandId: string | undefined, campaignId: string | undefined) {
  return useQuery({
    queryKey: ["task-runs-campaign", brandId, campaignId],
    queryFn: () =>
      api.get<{ data: TaskRun[] }>(
        `/api/task-runs?brand_id=${encodeURIComponent(brandId!)}&campaign_id=${encodeURIComponent(campaignId!)}&limit=50`,
      ),
    enabled: !!brandId && !!campaignId,
    retry: false,
  });
}
